import { render, staticRenderFns } from "./PurposeViewEdit.vue?vue&type=template&id=0d015978&scoped=true"
import script from "./PurposeViewEdit.vue?vue&type=script&lang=js"
export * from "./PurposeViewEdit.vue?vue&type=script&lang=js"
import style0 from "./PurposeViewEdit.vue?vue&type=style&index=0&id=0d015978&prod&lang=css"
import style1 from "./PurposeViewEdit.vue?vue&type=style&index=1&id=0d015978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d015978",
  null
  
)

export default component.exports